<div
  class="catalog-card-skeleton"
  [class.catalog-card-skeleton--tile]="variant() === 'tile'"
  [class.catalog-card-skeleton--list]="variant() === 'list'"
  aria-hidden="true">
  <!-- Image placeholder (darker grey) -->
  <div class="catalog-card-skeleton__image skeleton-block skeleton-block--dark"></div>

  <!-- Content placeholder -->
  <div class="catalog-card-skeleton__content">
    <!-- Title (darker grey) -->
    <div class="catalog-card-skeleton__title skeleton-block skeleton-block--dark"></div>

    <!-- Location / meta row (2 bars) -->
    <div class="catalog-card-skeleton__meta">
      <div class="catalog-card-skeleton__meta-item skeleton-block"></div>
      <div class="catalog-card-skeleton__meta-item catalog-card-skeleton__meta-item--sm skeleton-block"></div>
    </div>

    <!-- Pills row: 1 pill on web, 2 pills on mobile (Figma 79-4730) -->
    <div class="catalog-card-skeleton__pills">
      <div class="catalog-card-skeleton__pill skeleton-block"></div>
      <div class="catalog-card-skeleton__pill catalog-card-skeleton__pill--secondary skeleton-block"></div>
    </div>

    <!-- Category badges (web only) -->
    <div class="catalog-card-skeleton__badges">
      <div class="catalog-card-skeleton__badge skeleton-block"></div>
      <div class="catalog-card-skeleton__badge catalog-card-skeleton__badge--sm skeleton-block"></div>
    </div>

    <!-- Description lines -->
    <div class="catalog-card-skeleton__lines">
      <div class="catalog-card-skeleton__line skeleton-block"></div>
      <div class="catalog-card-skeleton__line skeleton-block"></div>
      <div class="catalog-card-skeleton__line catalog-card-skeleton__line--short skeleton-block"></div>
    </div>

    <!-- Tag box (mobile only) -->
    <div class="catalog-card-skeleton__tag skeleton-block"></div>

    <!-- Action buttons (left button darker grey) -->
    <div class="catalog-card-skeleton__actions">
      <div class="catalog-card-skeleton__button catalog-card-skeleton__button--primary skeleton-block skeleton-block--dark"></div>
      <div class="catalog-card-skeleton__button skeleton-block"></div>
    </div>
  </div>
</div>
